import { render, staticRenderFns } from "./CorrespondenceVotesTable.vue?vue&type=template&id=125e19a7&"
import script from "./CorrespondenceVotesTable.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceVotesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports